export function getDate(date: Date): string {
    const day: number = date.getDate();
    const month: number = date.getMonth() + 1;
    const year: number = date.getFullYear();
    
    return day + "." + month + "." + year;
}

export function getClockTime(date: Date): string {
    const hours: number = date.getHours();
    const minutes: number = date.getMinutes();
    const minutesZero: string = minutes < 10 ? "0" + minutes : minutes.toString();
    
    return hours + ":" + minutesZero;
}

export function getDurationInSeconds(endTime: Date, startTime: Date): number {
    const durationSeconds = (endTime.getTime() - startTime.getTime()) / 1000.0;
    return isNaN(durationSeconds) ? 0 : Math.round(durationSeconds);
}

export function getMins(allSeconds: number): number {
    if (allSeconds < 60) return 0;
    let mins = Math.floor(allSeconds / 60);
    return isNaN(mins) ? 0 : mins;
}

export function getSeconds(allSeconds: number): number {
    if (allSeconds < 60) return allSeconds;

    let secs = Math.floor(((allSeconds / 60) - getMins(allSeconds)) * 60);
    return isNaN(secs) ? 0 : secs;
}
